const cards = [
  {
    title: '《流浪地球3》抢先版上线',
    desc: '国产科幻巨制第三部，视觉特效全面升级，人类命运再临抉择',
    tag: '新片推荐',
    tagColor: 'primary',
    img: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20style%20image%20with%20epic%20space%20scene%2C%20dramatic%20lighting%2C%20futuristic%20elements%2C%20deep%20blue%20and%20orange%20contrast%2C%20cinematic%20composition%2C%20dark%20atmospheric%20background&width=600&height=840&seq=card-poster-11&orientation=portrait',
  },
  {
    title: '《庆余年》第三季全集',
    desc: '范闲归来，庙堂风云再起，权谋与武侠交织的史诗续章',
    tag: '剧集热播',
    tagColor: 'accent',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20aesthetic%20with%20ancient%20palace%20elements%2C%20warm%20golden%20and%20crimson%20tones%2C%20dramatic%20silhouette%20composition%2C%20martial%20arts%20theme%2C%20dark%20moody%20background&width=600&height=840&seq=card-poster-12&orientation=portrait',
  },
  {
    title: '《龙族》动画剧场版',
    desc: '江南原著改编，顶级制作水准，路明非的屠龙之旅震撼开启',
    tag: '动漫精选',
    tagColor: 'secondary',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20poster%20with%20dragon%20silhouette%2C%20vibrant%20golden%20and%20crimson%20color%20scheme%2C%20dynamic%20action%20composition%2C%20epic%20scale%2C%20Japanese%20anime%20aesthetic%2C%20dark%20fantasy%20mood&width=600&height=840&seq=card-poster-13&orientation=portrait',
  },
  {
    title: '《脱口秀大会》新一季',
    desc: '全新阵容爆笑回归，段子升级笑点密集，这个夏天让快乐加倍',
    tag: '综艺热榜',
    tagColor: 'primary',
    img: 'https://readdy.ai/api/search-image?query=Comedy%20show%20poster%20style%20with%20spotlight%20stage%20lighting%2C%20warm%20theater%20atmosphere%2C%20microphone%20silhouette%2C%20energetic%20and%20fun%20vibe%2C%20dark%20background%20with%20colorful%20accents&width=600&height=840&seq=card-poster-14&orientation=portrait',
  },
  {
    title: '宫崎骏《你想活出怎样的人生》',
    desc: '奥斯卡获奖动画长片，宫崎骏倾注心血之作，关于生命与成长的思考',
    tag: '经典必看',
    tagColor: 'accent',
    img: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20animated%20film%20poster%20with%20dreamy%20pastoral%20landscape%2C%20soft%20watercolor%20texture%2C%20warm%20natural%20lighting%2C%20whimsical%20and%20emotional%20mood%2C%20hand-drawn%20aesthetic&width=600&height=840&seq=card-poster-15&orientation=portrait',
  },
  {
    title: '《速度与激情11》终极篇',
    desc: '家族传奇最终章，极限飙车场面震撼，速度系列的完美收官之作',
    tag: '动作大片',
    tagColor: 'secondary',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20sports%20car%20silhouette%2C%20dramatic%20urban%20night%20scene%2C%20neon%20lights%20and%20motion%20blur%2C%20high%20energy%20composition%2C%20cinematic%20adrenaline%20mood%2C%20dark%20atmospheric%20background&width=600&height=840&seq=card-poster-16&orientation=portrait',
  },
];

export default function CardsSection() {
  const tagStyles: Record<string, string> = {
    primary: 'bg-primary-500/15 text-primary-500',
    accent: 'bg-accent-500/15 text-accent-500',
    secondary: 'bg-secondary-100 text-secondary-600',
  };

  return (
    <section id="cards" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            影视推荐
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <div key={idx} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
              <div className="relative aspect-[5/7] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent"></div>
                <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${tagStyles[card.tagColor] || tagStyles.primary}`}>
                  {card.tag}
                </span>
                <div className="absolute bottom-3 right-3 w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-foreground-900 font-heading text-sm md:text-base font-bold mb-2 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}